/**
 * Click-to-zoom lightbox for the product media gallery.
 *
 * Reuses the gallery DOM instead of duplicating every image into a hidden modal:
 * each zoomable image carries data-zoom-src, and a single overlay is built on
 * first use and reused from then on.
 */
(function () {
  if (window.productMediaZoom) return;

  var overlay = null;
  var imageEl = null;
  var counterEl = null;
  var items = [];
  var index = 0;
  var openedBy = null;
  var pointerStart = null;

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'product-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('tabindex', '-1');
    overlay.innerHTML =
      '<div class="product-zoom__backdrop" data-zoom-close></div>' +
      '<button type="button" class="product-zoom__close" data-zoom-close aria-label="' +
      closeLabel() +
      '">&times;</button>' +
      '<button type="button" class="product-zoom__nav product-zoom__nav--prev" data-zoom-step="-1" aria-label="' +
      stepLabel('previous') +
      '">&#8249;</button>' +
      '<div class="product-zoom__content"><img class="product-zoom__image" alt=""></div>' +
      '<button type="button" class="product-zoom__nav product-zoom__nav--next" data-zoom-step="1" aria-label="' +
      stepLabel('next') +
      '">&#8250;</button>' +
      '<p class="product-zoom__counter" aria-live="polite"></p>';

    imageEl = overlay.querySelector('.product-zoom__image');
    counterEl = overlay.querySelector('.product-zoom__counter');

    overlay.addEventListener('click', function (event) {
      if (event.target.hasAttribute('data-zoom-close')) return hide();
      var step = event.target.closest('[data-zoom-step]');
      if (step) show(index + parseInt(step.dataset.zoomStep, 10));
    });

    document.body.appendChild(overlay);
  }

  function closeLabel() {
    return (window.accessibilityStrings && window.accessibilityStrings.closeModal) || 'Close';
  }

  function stepLabel(direction) {
    return direction === 'next' ? 'Next image' : 'Previous image';
  }

  function show(next) {
    if (!items.length) return;
    index = (next + items.length) % items.length;
    var item = items[index];
    imageEl.src = item.src;
    imageEl.alt = item.alt;
    counterEl.textContent = index + 1 + ' / ' + items.length;
    overlay.classList.toggle('product-zoom--single', items.length < 2);
  }

  function open(button) {
    if (!overlay) buildOverlay();

    var gallery = button.closest('.product__media-list') || button.closest('media-gallery') || document;
    // Media for the other shades is still in the DOM, just hidden - it should
    // not turn up when stepping through the lightbox.
    items = Array.prototype.filter
      .call(gallery.querySelectorAll('img[data-zoom-src]'), function (img) {
        var tile = img.closest('.product__media-item');
        return !tile || !!(tile.offsetWidth || tile.offsetHeight || tile.getClientRects().length);
      })
      .map(function (img) {
        return { src: img.dataset.zoomSrc, alt: img.alt || '', el: img };
      });

    var clicked = button.parentElement.querySelector('img[data-zoom-src]');
    var start = items.findIndex(function (item) {
      return item.el === clicked;
    });

    openedBy = button;
    document.body.classList.add('overflow-hidden');
    overlay.classList.add('product-zoom--open');
    show(start < 0 ? 0 : start);
    document.addEventListener('keydown', onKeydown);
    if (typeof trapFocus === 'function') trapFocus(overlay, overlay.querySelector('.product-zoom__close'));
  }

  function hide() {
    if (!overlay) return;
    overlay.classList.remove('product-zoom--open');
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keydown', onKeydown);
    if (typeof removeTrapFocus === 'function') removeTrapFocus(openedBy);
    openedBy = null;
  }

  function onKeydown(event) {
    if (event.key === 'Escape') return hide();
    if (event.key === 'ArrowRight') return show(index + 1);
    if (event.key === 'ArrowLeft') return show(index - 1);
  }

  // A swipe on the mobile carousel ends in a click on the overlay button, so
  // only treat it as a zoom when the pointer barely moved.
  document.addEventListener(
    'pointerdown',
    function (event) {
      pointerStart = { x: event.clientX, y: event.clientY };
    },
    true
  );

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.product__media-zoom');
    if (!button) return;
    // event.detail is 0 for keyboard activation, which has no pointer to compare.
    if (pointerStart && event.detail > 0) {
      var moved = Math.abs(event.clientX - pointerStart.x) + Math.abs(event.clientY - pointerStart.y);
      if (moved > 10) return;
    }
    event.preventDefault();
    open(button);
  });

  window.productMediaZoom = { open: open, hide: hide };
})();
